import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {useMultiStyleConfig, VStack, Box, Flex} from '@chakra-ui/react'
import BenefitCard from './benefit-card'
import {BenefitDeliveryIcon, CareShieldIcon} from '../icons'
import {warranty} from './benefit-labels'
import PreorderBackorderLabel from '../preorder-backorder-label'

const Benefits = ({product, orderStatus}) => {
    const styles = useMultiStyleConfig('Benefits')
    const benefitCardStyles = useMultiStyleConfig('BenefitCard')

    const showPreorderBackorderLabel =
        product && orderStatus && (orderStatus.isPreorder || orderStatus.isBackorder)

    const variant = orderStatus?.isPreorder
        ? 'preorder'
        : orderStatus?.isBackorder
        ? 'backorder'
        : null

    return (
        <VStack {...styles.benefitStack}>
            {showPreorderBackorderLabel && variant && (
                <Box {...benefitCardStyles.card}>
                    <BenefitDeliveryIcon {...styles.icon} />
                    <Flex {...benefitCardStyles.textContainter}>
                        <PreorderBackorderLabel product={product} variant={variant} />
                    </Flex>
                </Box>
            )}

            <BenefitCard
                icon={<CareShieldIcon {...styles.icon} />}
                benefitText={<FormattedMessage {...warranty.benefitText} />}
            />
        </VStack>
    )
}

Benefits.propTypes = {
    product: PropTypes.object,
    orderStatus: PropTypes.shape({
        isPreorder: PropTypes.bool,
        isBackorder: PropTypes.bool,
    }),
}

export default Benefits
